import { useTranslation } from 'react-i18next';
import { namespaces } from '../../locales/namespaces';

export const useCommonTranslation = () => useTranslation(namespaces);
